import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";

import { ref, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XCommonDialog',
  props: {
    title: {},
    width: {},
    className: {}
  },
  emits: ['close', 'open'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const visible = ref(false);
    watch(visible, () => {
      if (!visible.value) {
        emits('close');
      }
    });
    function open(data) {
      visible.value = true;
      emits('open', data);
    }
    function close() {
      visible.value = false;
    }
    __expose({
      open,
      close
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: _normalizeClass(_ctx.className),
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        title: _ctx.title,
        width: _ctx.width,
        onClose: close
      }, {
        footer: _withCtx(() => [_renderSlot(_ctx.$slots, "footer")]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["class", "modelValue", "title", "width"]);
    };
  }
});